// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3P7Jk","errorLogs":"styles_errorLogs__1EFCj"};